import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Engines.scss";
import CommonTabs from "../../../common/Pilots/CommonTabs/CommonTabs";
import { VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH } from "../../../../helper/APIPaths";
import { useTranslation } from "react-i18next";
import { COMMON_MESSAGES, VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from "../../../../helper/constants";
import CircularLoader from "../../../common/Loader/CircularLoader";
import { isPilot } from "../../../../helper/commonFunctions";
import { setMenuSelection } from "../../../../storage/reducers/menuSelectorReducer";

const EnginesList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabTitles, setTabTitles] = useState<Array<object>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { userInformation } = useSelector((state: any) => state?.userInformation);
  const { subCategoryNameEngines } = useSelector((state: any) => state?.virtualClassRoomsOrEngines);
  const { itemCategory, pilot_category_name_EN, pilot_item_name_engines } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;

  useEffect(() => {
    if (tabTitles.length === 0) {
      fetchEnginesItemsElements();
    }
    dispatch(setMenuSelection({currentMenuTitle: subCategoryNameEngines}));
  }, [tabTitles.length]);

  const fetchEnginesItemsElements = useCallback(async () => {
    const payload = {
      pilot_category_name: pilot_category_name_EN,
      pilot_item_name: subCategoryNameEngines,
      type:itemCategory,
      role: isPilot(userInformation?.jobTitle || ""),
    };

    try {
        const response = await fetch(VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
        });
        const res = await response.json();
        const data = res?.data?.preflightData;
        if (data) {
          setTabTitles(data);
          setLoading(false);
          setError(false); 
        }

    } catch (ierror) {
      console.error(
        "Error while fetching virtual classrooms data details",
        ierror
      );
      setLoading(false);
      setError(true);
    }
  }, []);

  return (
    <div className="enginesContainer">
      {loading && <CircularLoader />}
      {tabTitles.length > 0 && <CommonTabs tabs={tabTitles} category={pilot_category_name_EN} />}
      {!loading && tabTitles.length === 0 && (
        <div className="error">{t(COMMON_MESSAGES.NO_RECORDS_FOUND)}</div>
      )}
      {error && (
        <div className="error">{t(COMMON_MESSAGES.NO_DATA_AVAILABLE)}</div>
      )}
    </div>
  );
};

export default EnginesList;
